<nav class="navbar navbar-expand-lg navbar-light bg-light" *ngIf="router.url !== '/peak'">
    <a class="navbar-brand" href="/juror">{{ title }}</a>
    <ul class="navbar-nav mr-auto">
      <li title='Juror Area'>
        <a class="nav-link active" [routerLink]="['/juror']">Juror</a>
      </li>
      <li title='{{stats.yesCount}} Images Selected'>
        <a class="nav-link" [routerLink]="['/juror/accepted']">Accepted <span class="badge badge-dark">{{stats.yesCount}}</span></a>
      </li>
      <li title='{{stats.noCount}} Submissions Rejected'>
        <a class="nav-link" [routerLink]="['/juror/rejected']">Rejected <span class="badge badge-dark">{{stats.noCount}}</span></a>
      </li>
      <li title='{{stats.unreviewedCount}} Images have not been reviewed'>
        <a class="nav-link" [routerLink]="['/juror/unrated']">Unrated <span class="badge badge-danger">{{stats.unreviewedCount}}</span></a>
      </li>
    </ul>
</nav>